module.exports = {"513326100":"鲜水镇","513326101":"八美镇","513326102":"亚卓镇","513326103":"甲宗镇","513326200":"格西乡","513326201":"麻孜乡","513326202":"孔色乡","513326203":"葛卡乡","513326205":"仲尼乡","513326206":"红顶乡","513326207":"扎拖乡","513326208":"下拖乡","513326209":"瓦日乡","513326210":"木茹乡","513326211":"甲斯孔乡","513326213":"七美乡","513326214":"银恩乡","513326215":"维它乡","513326216":"龙灯乡","513326217":"协德乡","513326218":"色卡乡","513326219":"沙冲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513326.json
// module id = 2231
// module chunks = 0